import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M22.4072 8.38281H56V35.4561H22.4072V44L0 21.9189L22.4072 0V8.38281ZM11.418 21.9395L17.0156 27.4561H48V16.3828H17.0996L11.418 21.9395Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 44

/**
 * Arrow Left cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const ArrowLeftCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ArrowLeftCutoutShape

